/**
 * Question Form Handler
 * Handles multiple instances of the form on a single page using Vanilla JS.
 */
class QuestionForm {
  constructor(blockId) {
    this.blockId = blockId;
    this.host = "https://noticeboard.kontech.com.cn/shopifyserverConsume/Shopify/";
    
    // 获取当前实例的弹窗容器
    this.modal = document.getElementById(`dialog-${blockId}`);
    if (!this.modal) return;

    // 在当前容器内查找元素 (Scope selection to this modal instance)
    this.formGroup = this.modal.querySelector('.form-group-container');
    this.successContainer = this.modal.querySelector('.question-form-success-contair');
    this.headerElement = document.querySelector('.site-header__element--top');
    this.submitBtn = this.modal.querySelector('.js-submit-btn');
    this.closeBtn = this.modal.querySelector('.js-modal-close');
    
    // 输入框引用
    this.emailInput = this.modal.querySelector('input[name="questionemail"]');
    this.nameInput = this.modal.querySelector('input[name="questionusername"]');
    this.phoneInput = this.modal.querySelector('input[name="questioncellPhone"]');
    this.remarkInput = this.modal.querySelector('textarea');
    this.counter = this.modal.querySelector('.js-desc-counter');

    this.isSubmitting = false;

    this.init();
  }

  init() {
    this.bindEvents();
  }

  // 绑定事件
  bindEvents() {
    // 1. 关闭按钮
    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', () => this.close());
    }

    // 2. 提交按钮
    if (this.submitBtn) {
      this.submitBtn.addEventListener('click', () => this.handleSubmit());
    }

    // 3. 输入验证移除错误样式
    [this.emailInput, this.nameInput, this.phoneInput].forEach(input => {
      if (input) {
        input.addEventListener('input', () => input.classList.remove('error-input'));
        input.addEventListener('change', () => input.classList.remove('error-input'));
      }
    });

    // 4. 字数统计
    if (this.remarkInput) {
      this.remarkInput.addEventListener('input', (e) => {
        const len = e.target.value.length;
        if (this.counter) this.counter.innerText = `${len}/2000`;
      });
    }
  }

  open() {
    // 显示弹窗
    this.modal.style.display = 'block'; 
    this.modal.classList.remove('fade-out');
    this.modal.classList.add('fade-in'); 
    if (this.formGroup) this.formGroup.style.display = 'block';
    if (this.successContainer) this.successContainer.style.display = 'none';
    if (this.headerElement) this.headerElement.style.display = 'none';

    this.disableScroll();
  }

  close() {
    this.modal.classList.remove('fade-in');
    this.modal.classList.add('fade-out');
    if (this.headerElement) this.headerElement.style.display = '';
    this.enableScroll();
    this.resetForm();
    setTimeout(() => {
      if (this.modal.classList.contains('fade-out')) {
         this.modal.style.display = 'none'; 
         this.modal.classList.remove('fade-out'); 
      }
    }, 280);
  }

  handleSubmit() {
    if (this.isSubmitting) return this.showToast("Requesting...");

    // 验证逻辑
    let hasError = false;
    const requiredFields = [this.emailInput, this.nameInput, this.phoneInput];

    requiredFields.forEach(input => {
      if (!input) return;
      if (!input.value.trim()) {
        input.classList.add("error-input");
        hasError = true;
      }
    });

    if (hasError) return this.showToast("Incomplete required fields");

    // 浏览器原生 Email 格式验证
    if (this.emailInput && !this.emailInput.checkValidity()) {
      this.emailInput.reportValidity();
      return;
    }

    this.submitData();
  }

  async submitData() {
    // 获取 Radio 值 (需要在当前 Modal 内查找 checked 的 radio)
    const needVal = this.modal.querySelector('input[name^="questionNeed"]:checked')?.value || "";
    const contactVal = this.modal.querySelector('input[name^="questionContact"]:checked')?.value || "";
    const data = {
      email: this.emailInput.value,
      name: this.nameInput.value,
      phone: this.phoneInput.value,
      description: this.remarkInput.value,
      businessType: needVal,
      contactMethod: contactVal,
      shopName:'mx',
      isType:0,
      type:'Product Page Question Form',
    };

    // UI Loading 状态
    this.isSubmitting = true;
    const originalBtnText = this.submitBtn.innerHTML;
    this.submitBtn.disabled = true;
    this.submitBtn.innerHTML = "Submitting...";
    
    // 调用外部全局 Loading (保留原有逻辑)
    this.showFullscreenLoading();

    try {
      const response = await fetch(this.host + "insertShopifyServer", {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      });

      const res = await response.json();

      if (res.code == 200) {
        this.showToast("Submission Successful");
        if (this.formGroup) this.formGroup.style.display = 'none';
        if (this.successContainer) this.successContainer.style.display = 'block';
      } else {
        throw new Error('API Error');
      }
    } catch (error) {
      this.showToast("Submit failed");
      console.error(error);
    } finally {
      // 恢复状态
      this.isSubmitting = false;
      this.submitBtn.disabled = false;
      this.submitBtn.innerHTML = originalBtnText;
      this.hideFullscreenLoading();
    }
  }

  resetForm() {
    if (this.emailInput) this.emailInput.value = '';
    if (this.nameInput) this.nameInput.value = '';
    if (this.phoneInput) this.phoneInput.value = '';
    if (this.remarkInput) this.remarkInput.value = '';
    if (this.counter) this.counter.innerText = "0/2000";
    
    // 重置 Radio 到第一个选项
    const firstNeed = this.modal.querySelector('input[name^="questionNeed"]');
    if (firstNeed) firstNeed.checked = true;
    const firstContact = this.modal.querySelector('input[name^="questionContact"]');
    if (firstContact) firstContact.checked = true;
  }

  showToast(msg, duration = 2000) {
    const toast = document.getElementById("globalToast");
    if (!toast) {
      alert(msg); // Fallback
      return;
    }
    toast.innerText = msg;
    toast.classList.add("show");
    
    // 清除上一次的 Timer
    if (toast.timer) clearTimeout(toast.timer);
    
    toast.timer = setTimeout(() => {
      toast.classList.remove("show");
    }, duration);
  }
  showFullscreenLoading() {
    const loaderContent = document.querySelector(".loader-content");
    if (!loaderContent) return; // 安全检查
    
    const loaderText = loaderContent.querySelector("#loader-text");
    if(loaderText) loaderText.style.display = "none";
    
    let contentText = '<p class="loader-text-custom" style="margin:0;">We will contact you as soon as possible after receiving your information...</p>';
    
    // 避免重复添加
    if(!loaderContent.querySelector('.loader-text-custom')) {
      loaderContent.insertAdjacentHTML('beforeend', contentText);
    }
    
    PageLoader.show();
  }

  hideFullscreenLoading() {
    const loaderContent = document.querySelector(".loader-content");
    if (!loaderContent) return;

    const loaderText = loaderContent.querySelector("#loader-text");
    if(loaderText) loaderText.style.display = "block";
    
    const customText = loaderContent.querySelector(".loader-text-custom");
    if (customText) customText.remove();
    
    PageLoader.hide();
  }
  disableScroll() {
    document.body.style.overflow = 'hidden';
  }

  enableScroll() {
    document.body.style.overflow = '';
  }
}

document.addEventListener('DOMContentLoaded', function() {
  // 1. 存储所有的 Form 实例，避免重复创建
  const formInstances = {};

  // 2. 查找所有的“打开弹窗”按钮 (来自上一轮对话的 .js-question-btn)
  const triggerButtons = document.querySelectorAll('.js-question-btn');

  triggerButtons.forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      
      const blockId = this.getAttribute('data-block-id');
      if (!blockId) return;

      // 如果这个 Block 的 Form 还没初始化过，初始化它
      if (!formInstances[blockId]) {
        formInstances[blockId] = new QuestionForm(blockId);
      }
      // 打开对应的弹窗
      formInstances[blockId].open();
    });
  });
});